import { PartnerStatus, SearchType } from 'supporter';

export const PARTNERS_SEARCH_TYPE: Record<string, SearchType> = {
  partnerName: 'PARTNER_NAME',
  all: 'ALL',
  companyName: 'COMPANY_NAME',
  registrationNo: 'REGISTRATION_NO',
};
export const PARTNERS_STATUS: Record<string, PartnerStatus> = {
  waiting: 'WAITING',
  investigation: 'INVESTIGATION',
  active: 'ACTIVE',
  suspend: 'SUSPEND'
};
